(function () {
  const STORAGE_KEY = "dy_wishlist_v1";

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent("dy:wishlist:updated", { detail: items }));
  }

  function isInWishlist(productId) {
    const items = readWishlist();
    return items.some((x) => String(x.productId) === String(productId));
  }

  function addToWishlist(payload) {
    const items = readWishlist();

    // prevent duplicates by product id
    if (items.some((x) => String(x.productId) === String(payload.productId))) {
      return items;
    }

    items.unshift({
      productId: payload.productId,
      handle: payload.handle,
      variantId: payload.variantId,
      title: payload.title,
      url: payload.url,
      image: payload.image,
      addedAt: Date.now()
    });

    writeWishlist(items);
    return items;
  }

  function removeFromWishlist(productId) {
    const items = readWishlist().filter((x) => String(x.productId) !== String(productId));
    writeWishlist(items);
    return items;
  }

  function clearWishlist() {
    writeWishlist([]);
  }

  function updateCountUI() {
    const countEls = document.querySelectorAll("[data-wishlist-count]");
    const items = readWishlist();
    countEls.forEach((el) => (el.textContent = String(items.length)));
  }

  function setButtonState(btn) {
    const productId = btn?.dataset?.productId;
    if (!productId) return;

    const active = isInWishlist(productId);
    btn.classList.toggle("is-active", active);

    const icon = btn.querySelector(".dy-wishlist-icon");
    const text = btn.querySelector(".dy-wishlist-text");

    if (icon) icon.textContent = active ? "♥" : "♡";
    if (text) text.textContent = active ? "Wishlisted" : "Add to Wishlist";
  }

  function renderDrawer() {
    const listEl = document.querySelector("[data-wishlist-list]");
    if (!listEl) return;

    const items = readWishlist();

    if (!items.length) {
      listEl.innerHTML = `<p style="color:#666;margin:0;">Your wishlist is empty.</p>`;
      return;
    }

    listEl.innerHTML = items
      .map((item) => {
        return `
          <div class="dy-wishlist-item">
            <img src="${item.image}" alt="${item.title}">
            <div style="flex:1;">
              <div class="dy-wishlist-item__title">${item.title}</div>
              <div class="dy-wishlist-item__actions">
                <a class="dy-wishlist-link" href="${item.url}">View</a>
                <button class="dy-wishlist-remove" type="button" data-wishlist-remove="${item.productId}">
                  Remove
                </button>
              </div>
            </div>
          </div>
        `;
      })
      .join("");
  }

  function openDrawer() {
    const drawer = document.querySelector("[data-wishlist-drawer]");
    if (!drawer) return;

    drawer.classList.add("is-open");
    renderDrawer();
  }

  function closeDrawer() {
    const drawer = document.querySelector("[data-wishlist-drawer]");
    if (!drawer) return;

    drawer.classList.remove("is-open");
  }

  function bindWishlistButtons() {
    document.querySelectorAll("[data-wishlist-btn]").forEach((btn) => {
      setButtonState(btn);

      btn.addEventListener("click", () => {
        const payload = {
          productId: btn.dataset.productId,
          handle: btn.dataset.productHandle,
          variantId: btn.dataset.variantId,
          title: btn.dataset.title,
          url: btn.dataset.url,
          image: btn.dataset.image
        };

        const active = isInWishlist(payload.productId);

        if (active) {
          removeFromWishlist(payload.productId);
        } else {
          addToWishlist(payload);
        }

        setButtonState(btn);
        updateCountUI();
      });
    });
  }

  function bindDrawerEvents() {
    document.addEventListener("click", (e) => {
      const openBtn = e.target.closest("[data-wishlist-open]");
      const closeBtn = e.target.closest("[data-wishlist-close]");
      const clearBtn = e.target.closest("[data-wishlist-clear]");
      const removeBtn = e.target.closest("[data-wishlist-remove]");

      if (openBtn) openDrawer();
      if (closeBtn) closeDrawer();

      if (clearBtn) {
        clearWishlist();
        renderDrawer();
        updateCountUI();
        document.querySelectorAll("[data-wishlist-btn]").forEach(setButtonState);
      }

      if (removeBtn) {
        const productId = removeBtn.getAttribute("data-wishlist-remove");
        removeFromWishlist(productId);
        renderDrawer();
        updateCountUI();
        document.querySelectorAll("[data-wishlist-btn]").forEach(setButtonState);
      }
    });

    // keep drawer updated if wishlist changes somewhere else
    window.addEventListener("dy:wishlist:updated", () => {
      updateCountUI();
      renderDrawer();
    });
  }

  function init() {
    updateCountUI();
    bindWishlistButtons();
    bindDrawerEvents();
    
  }

  document.addEventListener("DOMContentLoaded", init);
})();
